import { render, staticRenderFns } from "./otherFile.vue?vue&type=template&id=6e05ca40&scoped=true"
import script from "./otherFile.vue?vue&type=script&lang=js"
export * from "./otherFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e05ca40",
  null
  
)

export default component.exports